import { Card, CardBody, CardTitle } from '@progress/kendo-react-layout';
import {  useState } from 'react';
import React from 'react';

function EnterpriseCard() {

    return (
        <div className='d-flex mt-5 enterprise-card justify-content-between align-items-center p-3'>
                <div>
                   <h4
                   className='enterprise mb-0'
                    >
                        Enterprise
                    </h4>
                </div>
                <div className='enterprise-content'>

                    <p className='mb-0'>
                        Contact us for custom packages that fit all your company's needs, and to learn more about our product offerings.
                    </p>
                    
                </div>
            <div>
                <a href="https://www.codelessone.com/contact-us/" target="_blank">
                    <div className='btn-enterprise-product text-center float-end'>
                        <a
                            href="https://www.codelessone.com/contact-us/" target="_blank">
                            Contact Sales
                        </a>
                    </div>
                </a>
            </div>
        </div>
    )
}

export default EnterpriseCard;